import { CommonModule } from '@angular/common'
import { Component, inject, input } from '@angular/core'
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { Router, RouterModule } from '@angular/router'
import { Observable } from 'rxjs'
import { AssetService } from 'src/app/core/services/asset.service'
import { IAssetCategoriesResponse } from 'src/app/core/interfaces/asset.interface'
import { RoutePaths } from 'src/app/core/data/route-paths.data'
import { GlobalDataService } from 'src/app/core/services/global-data.service'
import { SearchRoutePaths } from 'src/app/core/data/search-route-paths.data'
import { StorageService } from 'src/app/core/services/storage.service'

@Component({
  selector: 'app-browse-by-category',
  templateUrl: './browse-by-category.component.html',
  styleUrls: ['./browse-by-category.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule,
  ],
})
export class BrowseByCategoryComponent {
  readonly quantityAvailable = $localize`:@@browseByCategory_QuantityAvailable:{quantity} available`

  private _assetService = inject(AssetService)
  private _storageService = inject(StorageService)
  private _router = inject(Router)
  globalData = inject(GlobalDataService)

  enabled = input(false)
  styles = input<any>({})
  display = input(false)
  quantity = input(5, {
    transform: (value: any) => parseInt(value, 10),
  })

  categories$!: Observable<IAssetCategoriesResponse>

  RoutePaths = RoutePaths
  SearchRoutePaths = SearchRoutePaths

  constructor() {
    toObservable(this.quantity).pipe(
      takeUntilDestroyed(),
    ).subscribe(() => {
      this.loadCategories()
    })
  }

  loadCategories(): void {
    this.categories$ = this._assetService.getCategories({
      field: 'quantity',
      direction: 'desc',
      index: 0,
      size: this.quantity(),
    }, [
      'category',
      'image',
      'list_price',
      'quantity',
    ])
  }

  loadAndOpenCategoryFilters(): void {
    this._storageService.setItem('openCategoryOnLoad', 'true', 'session')
    this._router.navigate([RoutePaths.Search])
  }
}
